import { Loading } from 'carbon-components-react'
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper'
import TileHeader from '../../components/TileHeader/TileHeader'
import styled from 'styled-components'
// hooks
import useUsersGrid from './useUsersGrid'

const Users = () => {
  const {
    addUserButton,
    userSearch,
    usersGrid,
    userLoading,
  } = useUsersGrid()

  return (
    <Container>
      <ContentContainer>
        <TileHeader
          title="Users"
          size="lg"
        />
        {
          userLoading ?
            <Loading/>
            :
            <></>
        }
        <UsersContent>
          <ActionBar>
            {userSearch()}
            {addUserButton()}
          </ActionBar>
          {usersGrid()}
        </UsersContent>
      </ContentContainer>
    </Container>
  )
}

export default Users

const UsersContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
